import React from "react";
import axios from "axios";
import { Button, UncontrolledTooltip } from "reactstrap";
import Swal from "sweetalert2";

function Status(props) {
  const URL_STATUS = `${props.URL_STATUS}/${props.idStatus}`;
  const URL_BAJA_HIJO = `${props.hijo}/${props.idStatus}`;

  const cambiarEstado = (nuevoStatus, nuevoActivo, textoAlerta) => {
    Swal.fire({
      title: "¿Estás seguro?",
      text: `Se ${textoAlerta}!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: `Sí, ${textoAlerta}!`,
    }).then((result) => {
      if (result.isConfirmed) {
        Promise.all([
          axios.patch(
            URL_STATUS,
            { status: nuevoStatus },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          ),
          axios.patch(
            URL_BAJA_HIJO,
            { is_active: nuevoActivo },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          ),
        ])
          .then(() => {
            Swal.fire({
              position: "center",
              icon: "success",
              title: `Se ${textoAlerta}`,
              showConfirmButton: false,
              timer: 1500,
            });

            // ✅ Notificar al componente padre
            if (typeof props.onStatusChange === "function") {
              props.onStatusChange(props.idStatus, nuevoStatus, nuevoActivo);
            }
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Ocurrió un error",
              footer: `${error.response?.data || error.message}`,
            });
            console.error(error);
          });
      }
    });
  };

  const btnId = `status-${props.idStatus}`;
  return (
    <>
      {props.status === "Abierto" ? (
        <>
          <Button
            color="primary"
            id={btnId}
            onClick={() => cambiarEstado("Cerrado", "No", "Cerrará")}
            size="sm"
          >
            <i className="fas fa-lock-open"></i>
          </Button>
          <UncontrolledTooltip placement="top" target={btnId}>Cerrar pedido</UncontrolledTooltip>
        </>
      ) : (
        <>
          <Button
            color="danger"
            id={btnId}
            onClick={() => cambiarEstado("Abierto", "Si", "Abrirá")}
            size="sm"
          >
            <i className="fas fa-lock"></i>
          </Button>
          <UncontrolledTooltip placement="top" target={btnId}>Abrir pedido</UncontrolledTooltip>
        </>
      )}
    </>
  );
}

export default Status;
